import { types } from 'mobx-state-tree';

const KeywordFilterModel = types
    .model('KeywordFilter', {
        name: types.string,
        subtitle: types.string,
        title: types.string,
        type: types.literal('Text'),
        value: types.string,
    })
    .views(self => ({
        get selectedOptions() {
            if (!self.value.length) return [];
            return [
                {
                    id: self.name,
                    subtitle: self.value,
                    title: self.value,
                    name: self.name,
                    value: self.value,
                },
            ];
        },

        get valueForQuery() {
            const value = self.value.trim();
            return value.length ? value : null;
        },

        isMatch(value = '') {
            return value === self.value;
        },
    }))
    .actions(self => ({
        setValue(value = '') {
            self.value = value;
        },

        clear() {
            self.value = '';
        },

        reset() {
            self.value = '';
        },
    }));

export default KeywordFilterModel;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/models/KeywordFilterModel.js